module.exports = __webpack_public_path__ + "img/vision_02_2x.78482561.webp";